module.exports = __webpack_public_path__ + "img/20191204172033360截图20191204163829321.9450eb47.jpg";